var moya = moya || {};
moya.sereq = moya.sereq || {};

jQuery.extend(moya.sereq, {
	asset: {
		exists: function(no) {
			if (no) {
				$.ajax({
					method: 'POST',
					url: '/_/moya/sereq/ajax/checkAsset',
					data: {
						no: no
					}
				}).done(function(response) {
					if (response === '1') {
						$('#elm_langtimaNotice', '#sereqBookingForm')
							.removeClass('hidden');

						$('#submitForm', '#sereqBookingForm')
							.addClass('disabled')
							.attr('disabled', true);
					}
					else {
						$('#elm_langtimaNotice', '#sereqBookingForm')
							.addClass('hidden');

						$('#submitForm', '#sereqBookingForm')
							.removeClass('disabled')
							.attr('disabled', false);
					}
				})
			}
		}
	},
	booking: {
		onLoad: function() {
			var no = $('#registrationNumber', '#sereqBookingForm').val();
			if (no.length > 2) {
				moya.sereq.asset.exists(no);
			}
		},
		onRegistrationNumberBlur: function(event) {
			var $target = $(event.target);

			no = moya.sereq.form.cleanRegistrationNumber($target.val());
			$target.val(no);

			if (no.length > 2) {
				moya.sereq.asset.exists(no);
			}
		}
	}
});
